module.exports = __webpack_public_path__ + "static/media/signing-document-rd.e609fdd9.jpg";